import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import AirworthyControl from 'pages/MaintenancePage/components/DroneCard/components/AirworthyControl';
import LifecycleControl from 'pages/MaintenancePage/components/DroneCard/components/LifecycleControl';

import { AIRWORTHY_CONTROL_TEST_ID, LIFECYCLE_CONTROL_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DrawerHead: FunctionComponent<Props> = ({
    className = '',
    drone,
    isAdmin,
    onClose,
    onSetAirworthy,
    onSetLifecycle,
    testId = TEST_ID
}) => (
    <HorizontalContainer className={`${styles.drawerHead} ${className}`} testId={testId}>
        <VerticalContainer className={styles.drawerTitle}>
            <Wrapper className={styles.drawerName}>{drone.name}</Wrapper>

            <Wrapper className={styles.drawerSerial}>{drone.serial}</Wrapper>
        </VerticalContainer>

        <AirworthyControl
            className={styles.drawerAirworthy}
            droneId={drone.id}
            isAdmin={isAdmin}
            onSetAirworthy={onSetAirworthy}
            readiness={drone.readiness}
            testId={AIRWORTHY_CONTROL_TEST_ID}
        />

        <LifecycleControl
            className={styles.drawerLifecycle}
            droneId={drone.id}
            isAdmin={isAdmin}
            onSetLifecycle={onSetLifecycle}
            status={drone.lifecycleStatus}
            testId={LIFECYCLE_CONTROL_TEST_ID}
        />

        <Wrapper className={styles.drawerClose} onClick={onClose}>
            ×
        </Wrapper>
    </HorizontalContainer>
);

export default DrawerHead;
